import ExerciseStore from '../storage/ExerciseStore.js'
import Performance from '../storage/Performance.js'
import PerformanceStore from '../storage/PerformanceStore.js'
import WorkoutStore from '../storage/WorkoutStore.js'

class PerformExercise extends HTMLElement {
  static observedAttributes = ["laterality", "measure", "exercise-type"]

  attributeChangedCallback(name, oldValue, newValue) {
    if (name !== "laterality" && name !== "measure" && name !== "exercise-type") {
      console.warn("Unknown attribute %s given value %s", name, newValue)
    }
    this.#render()
  }

  show(exercise) {
    this.setAttribute("laterality", exercise.laterality)
    this.setAttribute("measure", exercise.measure)
    this.setAttribute("exercise-type", exercise.exerciseType)
    this.querySelector("h2").textContent = exercise.exerciseName
    const form = this.querySelector("form")
    form.elements["exerciseId"].value = exercise.id
    form.elements["valueLeft"].value = exercise.valueLeft
    form.elements["valueRight"].value = exercise.valueRight ?? ""
    form.elements["sets"].value = exercise.sets ?? 1
    form.elements["notes"].value = ""
    const previousPerformance = PerformanceStore.getLatestForExercise(exercise.id)
    if (previousPerformance && previousPerformance.notes) {
      form.elements["notes"].value = previousPerformance.notes
    }
  }

  #complete = () => {
    this.querySelector("form").requestSubmit()
  }

  #cancel = () => {
    this.dispatchEvent(new CustomEvent("gime-exercise-done", { bubbles: true }))
  }

  #submit = (event) => {
    event.preventDefault()
    const form = event.currentTarget
    const formData = Object.fromEntries(new FormData(form))
    const { exerciseId, notes, valueLeft, valueRight, sets } = formData

    const exercise = ExerciseStore.get(exerciseId)
    exercise.valueLeft = valueLeft
    exercise.valueRight = valueRight
    if (exercise.exerciseType !== "cardio") {
      exercise.sets = Number(sets)
    }
    ExerciseStore.update(exercise)

    const workout = WorkoutStore.getCurrent()
    const performance = {
      workoutId: workout.id,
      exerciseId,
      notes,
      valueLeft,
      valueRight,
      completedAt: new Date().toISOString(),
    }
    if (exercise.exerciseType !== "cardio") {
      performance.sets = Number(sets)
    }
    PerformanceStore.create(new Performance(performance))

    this.dispatchEvent(new CustomEvent("gime-exercise-done", { bubbles: true }))
  }

  #render() {}

  connectedCallback() {
    this.querySelector("[data-complete]").addEventListener("click", this.#complete)
    this.querySelector("[data-cancel]").addEventListener("click", this.#cancel)
    this.querySelector("form").addEventListener("submit", this.#submit)
    this.#render()
  }
}

export default PerformExercise
